import React from 'react';

import { Footer, Header, PageLayout } from '../../components';
import PageContent from '../../features/AddSim';
import { useAuthValidation } from '../../utils/hooks';

const AddSimPage = () => {
  useAuthValidation();

  return (
    <>
      <Header />
      <PageLayout>
        <PageContent />
      </PageLayout>
      <Footer />
    </>
  );
};

export default AddSimPage;
